import { DocumentType, LanguageType } from '@innedit/innedit-type';
import classnames from 'classnames';
import { LanguageData } from 'packages/innedit';
import React, { FC, useEffect, useState } from 'react';

import {
  Box,
  DataWithChildren,
  DataWithChildrenProps,
} from '../../packages/formidable';

export interface DataLanguagesTraductionsProps
  extends Omit<DataWithChildrenProps, 'componentType'> {
  espaceId: string;
  formName: string;
  name: string;
  type?: 'minimal' | 'group';
}

const DataLanguagesTraductions: FC<DataLanguagesTraductionsProps> = ({
  espaceId,
  className,
  datas,
  formName,
  name,
  type,
}) => {
  const [langues, setLangues] = useState<DocumentType<LanguageType>[]>();

  useEffect(() => {
    let isMounted = true;
    const featureData = new LanguageData({
      espaceId,
    });

    featureData
      .find({
        wheres: {
          hidden: false,
        },
      })
      .then(documents => {
        if (isMounted) {
          setLangues(documents);
        }

        return true;
      })
      .catch(error => console.error(error.message));

    return () => {
      isMounted = false;
    };
  }, [espaceId]);

  if (!langues || 0 === langues.length) {
    return null;
  }

  if ('minimal' === type) {
    return (
      <>
        {langues &&
          langues.map(langue => (
            <Box
              key={langue.id}
              className={classnames('flex !w-auto flex-row', className)}
            >
              <div className="pt-5">
                <div className="-rotate-90 transform">{langue.label}</div>
              </div>
              <div className="w-full flex-1">
                <DataWithChildren
                  componentType="flex"
                  datas={[
                    {
                      datas,
                      formName,
                      componentType: 'section',
                      name: `${name}.${langue.key}`,
                    } as DataWithChildrenProps,
                  ]}
                  formName={formName}
                />
              </div>
            </Box>
          ))}
      </>
    );
  }

  return (
    <>
      {langues &&
        langues.map(langue => (
          <DataWithChildren
            key={langue.id}
            componentType="group"
            datas={[
              {
                datas,
                formName,
                componentType: 'section',
                name: `${name}.${langue.key}`,
              } as DataWithChildrenProps,
            ]}
            formName={formName}
            title={langue.label}
          />
        ))}
    </>
  );
};

export default DataLanguagesTraductions;
